import React, { useEffect } from "react";
import clsx from 'clsx';
import useLoading from "../../hooks/useLoading";

const SpinnerLoading = () => {

  const { loading } = useLoading();

  return (
    loading.isShowSpinner 
    ? (
      <div className={ clsx( 'loading_layer', '1' === loading.spinnerType ? '' : `loading${ loading.spinnerType }` ) }>
        <div className="spinner">
          <div className="lds-spinner">
            <div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
          </div>
        </div>
      </div>
    )
    : (
      <></>
    )
  );

};

export default SpinnerLoading;
